import * as requestFromServer from "./Crud";
import {Slice, callTypes} from "./Slice";
import { NotificationManager } from "react-notifications";

const {actions} = Slice;

export const fetchList = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .getList(queryParams)
    .then((response) => {
      console.log("response::fetchList ", response);
      // const { totalCount, entities } = response.data;
      const totalCount = response?.count;
      const entities = response?.list;      
      dispatch(actions.listFetched({ totalCount, entities }));
      console.log("testttttttt", response.list)
      return response
    })
    .catch((error) => {
      console.log("error",error?.response?.data?.Error[0]?.msg)
      const errMsg = error?.response&&error?.response?.data&&error?.response?.data?.Error[0]&&error?.response?.data?.Error[0]?.msg ? error.response.data.Error[0].msg : "Method is not Impliment" ;
        NotificationManager.error(errMsg, 'Error');
        const totalCount = 0;
        const entities = [];      
        dispatch(actions.listFetched({ totalCount, entities }));
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchSingle = id => dispatch => {
  if (!id) {
    return dispatch(actions.singleItemFetched({ couponCategoryForEdit: undefined }));
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getItemById(id)
    .then(response => {
      const item = response;
      dispatch(actions.singleItemFetched({ couponCategoryForEdit: item }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteItem = id => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteItem(id)
    .then(response => {
      dispatch(actions.itemDeleted({ id }));
      NotificationManager.success('success', 'Data deleted successfully!');
      return response
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createItem = item => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createItem(item)
    .then(response => {
      const { item } = response;
      NotificationManager.success('success', 'Data saved successfully!');
      dispatch(actions.itemCreated({ item }));
      return true ;
    })
    .catch(error => {
      console.log("error",error?.response?.data?.Error[0]?.msg)
      const errMsg = error?.response&&error?.response?.data&&error?.response?.data?.Error[0]&&error?.response?.data?.Error[0]?.msg ? "Please Select Vaild Company" : "Method is not Impliment" ;
        NotificationManager.error(errMsg, 'Error');
        const { item } = {};
       
        dispatch(actions.itemCreated({ item }));
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const fetchCompanyList = (queryParams) => (dispatch) => {
  // console.log("queryParams",queryParams)
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .getCompany(queryParams)
    .then((response) => {
      // console.log("response::getGameList ", response);
      // const { totalCount, entities } = response.data;
      const totalCount = response.totalRecord;
      const entities = response.data;
      dispatch(actions.company({ totalCount, entities }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const updateItem = item => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateItem(item)
    .then(() => {
      NotificationManager.success('success', 'Data saved successfully!');
      dispatch(actions.itemUpdated({ item }));
      return true ;
    })
    .catch(error => {
      // error.clientMessage = "Can't update item";
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false ;
    });
};
export const updateStatus = item => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateStatus(item)
    .then(() => {
      NotificationManager.success('success', 'Data saved successfully!');
      dispatch(actions.itemUpdated({ item }));
      return true ;
    })
    .catch(error => {
      // error.clientMessage = "Can't update item";
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false ;
    });
};

export const fetchCompanyDropdownList = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .fetchCompanyDropdownList(queryParams)
    .then((response) => {
      console.log("response::All Company List", response);
      // const { totalCount, entities } = response.data;
      const companyDropdownList = response;
      console.log("fetchCompanyDropdownList", companyDropdownList);
      dispatch(actions.CompanyDropdownList({ companyDropdownList }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchCompanyDropdownList1 = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .fetchCompanyDropdownList1(queryParams)
    .then((response) => {
      console.log("response::All Company List", response);
      // const { totalCount, entities } = response.data;
      const companyDropdownList1 = response;
      console.log("fetchCompanyDropdownList1", companyDropdownList1);
      dispatch(actions.CompanyDropdownList1({ companyDropdownList1 }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const updateItemsStatus = (ids, status) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateItemsStatus(ids, status)
    .then(() => {
      dispatch(actions.itemStatusUpdated({ ids, status }));
    })
    .catch(error => {
      // error.clientMessage = "Can't update items status";
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};


export const deleteItems = ids => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteItems(ids)
    .then(() => {
      dispatch(actions.itemsDeleted({ ids }));

    })
    .catch(error => {
      // error.clientMessage = "Can't delete items";
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

